import React, { JSXElementConstructor, ReactElement, ReactNode, ReactPortal} from "react";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";

interface CustomTooltipProps {
  title: string | number | true | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal;
  children: ReactElement;
  placement?: TooltipProps["placement"];
  enterDelay?: number;
  offset?: [number, number];
  fontSize?: string | number;
  padding?: string | number;
}

export const CustomTooltip: React.FC<CustomTooltipProps> = ({
  title,
  children,
  placement = "bottom",
  enterDelay = 500,
  offset = [0, -30],
  fontSize = "0.85rem",
  padding = "6px 10px",
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      enterDelay={enterDelay}
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset,
            },
          },
        ],
      }}
      slotProps={{
        tooltip: {
          sx: {
            fontSize,
            padding,
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};
